import {
  ReactElement,
} from 'react';
import {
  Link,
} from 'react-router';
import {
  shallowEqual,
  useSelector,
  useDispatch,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
  DocumentResource,
} from '@gymcloud/core';

import {
  Text,
} from 'web-styled';

interface Props {
  href: string
  children: ReactElement<any>;
}

const mapState = state => ({
  isPro: coreSelectors.getProfile('is_pro')(state),
  documentsMap: coreSelectors.getResourceMap('documents')(state),
});

const DocumentLink = ({
  href,
  children,
}: Props) => {
  const { isPro, documentsMap } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();

  if (isPro) {
    return (
      <Link to={href}>
        {children}
      </Link>
    )
  }

  const id = href.split("/").pop() || ''
  const doc = documentsMap[id]

  const fetchDocument = () => {
    document.body.style.cursor = 'wait';

    dispatch(
      coreActions.requestGetDocument({
        id: Number(id),
        callbacks: {
          onSuccess: (doc: DocumentResource) => {
            document.body.style.cursor = 'default';
            window.open(doc.document_file.url, '_target')
          },
        },
      }),
    );
  }

  const linkProps = doc?.id ? {
    href: doc.document_file.url,
    target: "_blank",
  } : {
    href: '#',
    onClick: (e) => {
      e.preventDefault();
      if (!id) return
      fetchDocument()
    }
  }

  return (
    <Text
      as="a"
      color="link"
      {...linkProps}
    >
      {children}
    </Text>
  )
};

export default DocumentLink;
